<template>
    <div class="TxTemplateBlock">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "TxTemplateBlock"
    }
</script>

<style scoped>
    .TxTemplateBlock{
        overflow: hidden;
    }
</style>